import {
  ClientAreaApiClient,
  CreateSubscriptionDto,
  PaidPeriodTypeDto,
  RedemptionRequestDto,
} from 'common/api/autogenerated/client-area';
import { SubscriptionStatus } from 'common/api/autogenerated/client-area/models/SubscriptionStatus';

const clientAreaApiClient = new ClientAreaApiClient({
  BASE: '/client-area',
  WITH_CREDENTIALS: true,
});

export const getEarnProducts = () => clientAreaApiClient.earn.getApiEarnProducts();

export const createEarnSubscription = (data: CreateSubscriptionDto) =>
  clientAreaApiClient.earn.postApiEarnSubscriptions(data);
export const getEarnSubscriptions = () =>
  clientAreaApiClient.earn.getApiEarnSubscriptions(undefined, 1000, SubscriptionStatus.ACTIVE);

export const getEarnSubscriptionTransactions = (subscriptionId: number) =>
  clientAreaApiClient.earn.getApiEarnSubscriptionsTransactions(subscriptionId, undefined, 1000);

export const getEarnHistory = () =>
  clientAreaApiClient.earn.getApiEarnSubscriptions(undefined, 1000, SubscriptionStatus.CLOSED);

export const redeemSubscription = (subscriptionId: number, payload: RedemptionRequestDto) =>
  clientAreaApiClient.earn.postApiEarnSubscriptionsRedemption(subscriptionId, payload);

export const getEarnTotalPaidRewards = (period = PaidPeriodTypeDto.ALL_TIME) =>
  clientAreaApiClient.earn.getApiEarnSubscriptionsTotalPaid(period);

export const setAutoRenew = (subscriptionId: number, autoRenewEnabled: boolean) =>
  clientAreaApiClient.earn.putApiEarnSubscriptionsAutoRenewEnabled(subscriptionId, { autoRenewEnabled });
